<div class="pnl-showcase-register">
  <header>
      <div>
        <button (click)="onBack()" class="btn btn-primary-outline">Voltar</button>
        <button (click)="onCancelShowcase()" [disabled]="showcase==null" class="btn btn-primary-outline">Cancelar</button>
        <button (click)="onSubmit()" [disabled]="!changeDetail" class="btn btn-primary">Salvar</button>
      </div>
  </header>

  <form [formGroup]="showcaseFrm" (ngSubmit)="onSubmit()" novalidate>
    <section class="pnl pnl-content">
      <div class="fields">
        <div class="showcase-name">
          <label>Dê um nome para essa vitrine</label>
          <input type="text" class="form-control" formControlName="nome" (change)="onChangeDetail()" placeholder="Ex.: Queijos e Vinhos" />
        </div>
        <div class="showcase-origem">
          <label>Expor apenas</label>
          <ng-select [items]="origem" bindLabel="label" formControlName="tipo"  (change)="onChangeOrigin()" bindValue="id"></ng-select>
        </div>
        <div class="showcase-actions" [class.dnone]="tipo.value == 'C'">
          <label></label>
          <button *ngIf="produtos.length == 0" (click)="openModalProducts()" type="button" class="btn btn-primary">Pesquisar produtos</button>
          <button *ngIf="produtos.length > 0" (click)="openModalProducts()" type="button" class="btn btn-primary">
            <span><i>{{produtos.length}}</i> Produtos</span>
            <span>Adicionar +</span>
          </button>
        </div>
        <div  class="showcase-categories" [class.dnone]="tipo.value == 'P'">
          <label></label>
          <div class="dropdown-list">
            <span>{{ labelCategories }}</span>
            <ul>
              <li>
                <span>
                  <mat-checkbox id="ckOfertas" formControlName="oferta" (change)="findListProductsCat()" [checked]="oferta.value">Ofertas</mat-checkbox>
                </span>
              </li>
              <li>
                <span>
                  <mat-checkbox id="ckMaisVendidos" formControlName="mais_vendidos" (change)="findListProductsCat()" [checked]="mais_vendidos.value">Os mais vendidos</mat-checkbox>
                </span>
              </li>
              <li class="line">
                <b>Departamentos</b>
              </li>
              <li *ngFor="let category of categories; let i=index">
                <span>
                  <mat-checkbox [id]="'ckDep'+category.idcategoria" (change)="setCategory(category, $event.checked)" [checked]="category.checked" [value]="category.idcategoria">{{category.ds_categoria}}</mat-checkbox>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="list-products">
        <div class="cover image">
          <div class="no-cover" ng2FileDrop [uploader]="uploader" (fileOver)="fileOverBase($event)" [class.dnone]="((imageCapa!='' && imageCapa!='no') || (uploader.queue && uploader.queue.length > 0))" [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }">
            <i class="ic ic-no-image-big"></i>

            <span>Adicione um banner 240 x 400<br> para ilustrar a capa desta vitrine</span>

            <input id="fileUploader" #fileUploader type="file" ng2FileSelect [uploader]="uploader" class="dnone">

            <button (click)="fileUploader.click()" type="button" class="btn btn-secondary">Adicionar banner</button>
          </div>

          <div *ngIf="((uploader.queue && uploader.queue.length > 0) || (imageCapa != '')) && imageCapa!='auto' && imageCapa != 'no'" class="image-cover">
            <img [src]="imageCapa" *ngIf="imageCapa!=''" class="capa" />
            <img *ngFor="let item of uploader.queue; let i=index" src="" imgPreview [image]="item?._file"  class="capa" />
          </div>

          <svg *ngIf="isOffer && imageCapa=='auto'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="240" height="400" viewBox="36 0 240 400">
            <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_2" data-name="Rectangle 2" width="240" height="400" fill="none"/>
                </clipPath>
                <linearGradient id="linear-gradient" x1="0.121" y1="0.884" x2="0.907" y2="0.088" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#1a1514"/>
                <stop offset="1"/>
                </linearGradient>
            </defs>
            <g id="Group_2022" data-name="Group 2022" transform="translate(-145.555 -459)">
                <g id="BACKGROUND" transform="translate(183 459)">
                <g id="Group_57" data-name="Group 57">
                    <g id="Group_56" data-name="Group 56" clip-path="url(#clip-path)">
                    <g id="Group_55" data-name="Group 55" transform="translate(-406.689 -215.107)">
                        <rect id="Rectangle_1" data-name="Rectangle 1" width="240" height="400" transform="translate(406.689 215.107)" fill="url(#linear-gradient)"/>
                        <g id="Group_54" data-name="Group 54" opacity="0.05">
                        <g id="Group_1" data-name="Group 1" transform="translate(368.602)">
                            <path id="Path_1" data-name="Path 1" d="M-59.89,377.884-79.349-268.884h38.917Z" transform="translate(79.349 268.884)" fill="#fff"/>
                        </g>
                        <g id="Group_2" data-name="Group 2" transform="translate(237.051 27.913)">
                            <path id="Path_2" data-name="Path 2" d="M-202.4,384.862l-151.01-596.671,36.57-22.184Z" transform="translate(353.413 233.992)" fill="#fff"/>
                        </g>
                        <g id="Group_3" data-name="Group 3" transform="translate(177.179 70.435)">
                            <path id="Path_3" data-name="Path 3" d="M-267.266,395.493l-210.882-543.9,33.7-32.431Z" transform="translate(478.147 180.84)" fill="#fff"/>
                        </g>
                        <g id="Group_4" data-name="Group 4" transform="translate(123.714 130.469)">
                            <path id="Path_4" data-name="Path 4" d="M-325.186,410.5-589.532-64.105-559.72-105.8Z" transform="translate(589.532 105.798)" fill="#fff"/>
                        </g>
                        <g id="Group_5" data-name="Group 5" transform="translate(78.281 206.19)">
                            <path id="Path_5" data-name="Path 5" d="M-374.4,429.432-684.184,38.541l25.015-49.687Z" transform="translate(684.184 11.146)" fill="#fff"/>
                        </g>
                        <g id="Group_6" data-name="Group 6" transform="translate(42.261 295.298)">
                            <path id="Path_6" data-name="Path 6" d="M-413.426,451.709l-345.8-295.3,19.458-56.172Z" transform="translate(759.226 -100.239)" fill="#fff"/>
                        </g>
                        <g id="Group_7" data-name="Group 7" transform="translate(16.748 395.085)">
                            <path id="Path_7" data-name="Path 7" d="M-441.066,476.655-812.379,285.923l13.31-60.95Z" transform="translate(812.379 -224.973)" fill="#fff"/>
                        </g>
                        <g id="Group_8" data-name="Group 8" transform="translate(2.517 502.52)">
                            <path id="Path_8" data-name="Path 8" d="M-456.483,503.514l-385.544-80.372,6.758-63.876Z" transform="translate(842.027 -359.266)" fill="#fff"/>
                        </g>
                        <g id="Group_9" data-name="Group 9" transform="translate(0 614.337)">
                            <path id="Path_9" data-name="Path 9" d="M-459.209,531.468-847.27,563.9V499.037Z" transform="translate(847.27 -499.037)" fill="#fff"/>
                        </g>
                        <g id="Group_10" data-name="Group 10" transform="translate(2.517 646.768)">
                            <path id="Path_10" data-name="Path 10" d="M-456.483,539.576-835.269,683.824l-6.758-63.876Z" transform="translate(842.027 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_11" data-name="Group 11" transform="translate(16.748 646.768)">
                            <path id="Path_11" data-name="Path 11" d="M-441.066,539.576l-358,251.683-13.31-60.95Z" transform="translate(812.379 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_12" data-name="Group 12" transform="translate(42.261 646.768)">
                            <path id="Path_12" data-name="Path 12" d="M-413.426,539.576l-326.341,351.47-19.458-56.172Z" transform="translate(759.226 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_13" data-name="Group 13" transform="translate(78.281 646.768)">
                            <path id="Path_13" data-name="Path 13" d="M-374.4,539.576-659.168,980.154l-25.015-49.687Z" transform="translate(684.184 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_14" data-name="Group 14" transform="translate(123.714 646.768)">
                            <path id="Path_14" data-name="Path 14" d="M-325.186,539.576l-234.534,516.3-29.812-41.692Z" transform="translate(589.532 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_15" data-name="Group 15" transform="translate(177.179 646.768)">
                            <path id="Path_15" data-name="Path 15" d="M-267.266,539.576l-177.179,576.333-33.7-32.431Z" transform="translate(478.147 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_16" data-name="Group 16" transform="translate(237.051 646.768)">
                            <path id="Path_16" data-name="Path 16" d="M-202.4,539.576l-114.439,618.855-36.57-22.184Z" transform="translate(353.413 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_17" data-name="Group 17" transform="translate(301.512 646.768)">
                            <path id="Path_17" data-name="Path 17" d="M-132.572,539.576l-48.223,642.573-38.326-11.263Z" transform="translate(219.12 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_18" data-name="Group 18" transform="translate(368.602 646.768)">
                            <path id="Path_18" data-name="Path 18" d="M-59.89,539.576l19.459,646.768H-79.349Z" transform="translate(79.349 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_19" data-name="Group 19" transform="translate(388.061 646.768)">
                            <path id="Path_19" data-name="Path 19" d="M-38.81,539.576l86.549,631.31L9.413,1182.149Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_20" data-name="Group 20" transform="translate(388.061 646.768)">
                            <path id="Path_20" data-name="Path 20" d="M-38.81,539.576,112.2,1136.247l-36.57,22.184Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_21" data-name="Group 21" transform="translate(388.061 646.768)">
                            <path id="Path_21" data-name="Path 21" d="M-38.81,539.576l210.882,543.9-33.7,32.431Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_22" data-name="Group 22" transform="translate(388.061 646.768)">
                            <path id="Path_22" data-name="Path 22" d="M-38.81,539.576l264.347,474.607-29.812,41.692Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_23" data-name="Group 23" transform="translate(388.061 646.768)">
                            <path id="Path_23" data-name="Path 23" d="M-38.81,539.576,270.969,930.467l-25.015,49.687Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_24" data-name="Group 24" transform="translate(388.061 646.768)">
                            <path id="Path_24" data-name="Path 24" d="M-38.81,539.576l345.8,295.3-19.458,56.172Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_25" data-name="Group 25" transform="translate(388.061 646.768)">
                            <path id="Path_25" data-name="Path 25" d="M-38.81,539.576,332.5,730.309l-13.31,60.95Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_26" data-name="Group 26" transform="translate(388.061 646.768)">
                            <path id="Path_26" data-name="Path 26" d="M-38.81,539.576l385.544,80.372-6.758,63.876Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_27" data-name="Group 27" transform="translate(388.061 614.337)">
                            <path id="Path_27" data-name="Path 27" d="M-38.81,531.468,349.25,499.037V563.9Z" transform="translate(38.81 -499.037)" fill="#fff"/>
                        </g>
                        <g id="Group_28" data-name="Group 28" transform="translate(388.061 502.52)">
                            <path id="Path_28" data-name="Path 28" d="M-38.81,503.514,339.976,359.266l6.758,63.876Z" transform="translate(38.81 -359.266)" fill="#fff"/>
                        </g>
                        <g id="Group_29" data-name="Group 29" transform="translate(388.061 395.085)">
                            <path id="Path_29" data-name="Path 29" d="M-38.81,476.655l358-251.683,13.31,60.95Z" transform="translate(38.81 -224.973)" fill="#fff"/>
                        </g>
                        <g id="Group_30" data-name="Group 30" transform="translate(388.061 295.298)">
                            <path id="Path_30" data-name="Path 30" d="M-38.81,451.709l326.341-351.47,19.459,56.172Z" transform="translate(38.81 -100.239)" fill="#fff"/>
                        </g>
                        <g id="Group_31" data-name="Group 31" transform="translate(388.061 206.19)">
                            <path id="Path_31" data-name="Path 31" d="M-38.81,429.432,245.954-11.146l25.015,49.687Z" transform="translate(38.81 11.146)" fill="#fff"/>
                        </g>
                        <g id="Group_32" data-name="Group 32" transform="translate(388.061 130.469)">
                            <path id="Path_32" data-name="Path 32" d="M-38.81,410.5,195.724-105.8l29.812,41.692Z" transform="translate(38.81 105.798)" fill="#fff"/>
                        </g>
                        <g id="Group_33" data-name="Group 33" transform="translate(388.061 70.435)">
                            <path id="Path_33" data-name="Path 33" d="M-38.81,395.493,138.369-180.84l33.7,32.431Z" transform="translate(38.81 180.84)" fill="#fff"/>
                        </g>
                        <g id="Group_34" data-name="Group 34" transform="translate(388.061 27.913)">
                            <path id="Path_34" data-name="Path 34" d="M-38.81,384.862,75.629-233.992l36.57,22.184Z" transform="translate(38.81 233.992)" fill="#fff"/>
                        </g>
                        <g id="Group_35" data-name="Group 35" transform="translate(388.061 4.194)">
                            <path id="Path_35" data-name="Path 35" d="M-38.81,378.933,9.413-263.641l38.326,11.263Z" transform="translate(38.81 263.641)" fill="#fff"/>
                        </g>
                        <g id="Group_36" data-name="Group 36" transform="translate(368.602)">
                            <path id="Path_36" data-name="Path 36" d="M-59.89,377.884-79.349-268.884h38.917Z" transform="translate(79.349 268.884)" fill="#fff"/>
                        </g>
                        <g id="Group_37" data-name="Group 37" transform="translate(301.512 4.194)">
                            <path id="Path_37" data-name="Path 37" d="M-132.572,378.933l-86.549-631.31,38.326-11.263Z" transform="translate(219.12 263.641)" fill="#fff"/>
                        </g>
                        <g id="Group_38" data-name="Group 38" transform="translate(123.714 130.469)">
                            <path id="Path_38" data-name="Path 38" d="M-325.186,410.5-589.532-64.105-559.72-105.8Z" transform="translate(589.532 105.798)" fill="#fff"/>
                        </g>
                        <g id="Group_39" data-name="Group 39" transform="translate(42.261 295.298)">
                            <path id="Path_39" data-name="Path 39" d="M-413.426,451.709l-345.8-295.3,19.458-56.172Z" transform="translate(759.226 -100.239)" fill="#fff"/>
                        </g>
                        <g id="Group_40" data-name="Group 40" transform="translate(2.517 502.52)">
                            <path id="Path_40" data-name="Path 40" d="M-456.483,503.514l-385.544-80.372,6.758-63.876Z" transform="translate(842.027 -359.266)" fill="#fff"/>
                        </g>
                        <g id="Group_41" data-name="Group 41" transform="translate(2.517 646.768)">
                            <path id="Path_41" data-name="Path 41" d="M-456.483,539.576-835.269,683.824l-6.758-63.876Z" transform="translate(842.027 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_42" data-name="Group 42" transform="translate(42.261 646.768)">
                            <path id="Path_42" data-name="Path 42" d="M-413.426,539.576l-326.341,351.47-19.458-56.172Z" transform="translate(759.226 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_43" data-name="Group 43" transform="translate(123.714 646.768)">
                            <path id="Path_43" data-name="Path 43" d="M-325.186,539.576l-234.534,516.3-29.812-41.692Z" transform="translate(589.532 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_44" data-name="Group 44" transform="translate(237.051 646.768)">
                            <path id="Path_44" data-name="Path 44" d="M-202.4,539.576l-114.439,618.855-36.57-22.184Z" transform="translate(353.413 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_45" data-name="Group 45" transform="translate(368.602 646.768)">
                            <path id="Path_45" data-name="Path 45" d="M-59.89,539.576l19.459,646.768H-79.349Z" transform="translate(79.349 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_46" data-name="Group 46" transform="translate(388.061 646.768)">
                            <path id="Path_46" data-name="Path 46" d="M-38.81,539.576,112.2,1136.247l-36.57,22.184Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_47" data-name="Group 47" transform="translate(388.061 646.768)">
                            <path id="Path_47" data-name="Path 47" d="M-38.81,539.576l264.347,474.607-29.812,41.692Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_48" data-name="Group 48" transform="translate(388.061 646.768)">
                            <path id="Path_48" data-name="Path 48" d="M-38.81,539.576l345.8,295.3-19.458,56.172Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_49" data-name="Group 49" transform="translate(388.061 646.768)">
                            <path id="Path_49" data-name="Path 49" d="M-38.81,539.576l385.544,80.372-6.758,63.876Z" transform="translate(38.81 -539.576)" fill="#fff"/>
                        </g>
                        <g id="Group_50" data-name="Group 50" transform="translate(388.061 502.52)">
                            <path id="Path_50" data-name="Path 50" d="M-38.81,503.514,339.976,359.266l6.758,63.876Z" transform="translate(38.81 -359.266)" fill="#fff"/>
                        </g>
                        <g id="Group_51" data-name="Group 51" transform="translate(388.061 295.298)">
                            <path id="Path_51" data-name="Path 51" d="M-38.81,451.709l326.341-351.47,19.459,56.172Z" transform="translate(38.81 -100.239)" fill="#fff"/>
                        </g>
                        <g id="Group_52" data-name="Group 52" transform="translate(388.061 130.469)">
                            <path id="Path_52" data-name="Path 52" d="M-38.81,410.5,195.724-105.8l29.812,41.692Z" transform="translate(38.81 105.798)" fill="#fff"/>
                        </g>
                        <g id="Group_53" data-name="Group 53" transform="translate(388.061 27.913)">
                            <path id="Path_53" data-name="Path 53" d="M-38.81,384.862,75.629-233.992l36.57,22.184Z" transform="translate(38.81 233.992)" fill="#fff"/>
                        </g>
                        </g>
                    </g>
                    </g>
                </g>
                </g>
                <g id="Group_2019" data-name="Group 2019" transform="translate(177 449)">
                <g id="Group_60" data-name="Group 60" transform="translate(31.757 13.397)">
                    <path id="Path_63" data-name="Path 63" d="M383.607,104.7l.639-28.8,16.148,5.274Z" transform="translate(-211.682 -29.414)" fill="#ffb001"/>
                    <path id="Path_64" data-name="Path 64" d="M393.734,112.933,413.25,91.749l8.629,14.633Z" transform="translate(-259.694 -36.993)" fill="#fff"/>
                    <path id="Path_66" data-name="Path 66" d="M384.363,425.152l26.33,11.677L399.608,449.7Z" transform="translate(-211.604 -80.381)" fill="#fff"/>
                    <path id="Path_67" data-name="Path 67" d="M429.872,277.539l28.122-6.227-1.283,16.939Z" transform="translate(-269.998 -62.617)" fill="#fff"/>
                    <path id="Path_68" data-name="Path 68" d="M418.165,201.785l17.461-6.989.966,11.05Z" transform="translate(-247.492 -67.078)" fill="#ffb001"/>
                    <path id="Path_69" data-name="Path 69" d="M370.286,429.752l8.923,16.556-10.869,2.212Z" transform="translate(-211.441 -85.381)" fill="#ffb001"/>
                    <path id="Path_70" data-name="Path 70" d="M117.783,107.451l-16.106-9.712h0l8.231-7.436Z" transform="translate(-108.791 -28.56)" fill="#ffb001"/>
                    <path id="Path_71" data-name="Path 71" d="M118.3,338.962l-9.714,16.105-7.435-8.232Z" transform="translate(-98.76 -2.885)" fill="#ffb001"/>
                    <path id="Path_72" data-name="Path 72" d="M51.467,299.457,36.785,311.211l-4.131-10.295Z" transform="translate(-46.757 -65.931)" fill="#fff"/>
                    <circle id="Ellipse_1" data-name="Ellipse 1" cx="5.152" cy="5.152" r="5.152" transform="translate(34.829 115.946)" fill="#fff"/>
                    <circle id="Ellipse_2" data-name="Ellipse 2" cx="5.152" cy="5.152" r="5.152" transform="translate(-12.424 164.394)" fill="#fff"/>
                    <circle id="Ellipse_3" data-name="Ellipse 3" cx="2.576" cy="2.576" r="2.576" transform="translate(19.844 75.077)" fill="#fff"/>
                    <circle id="Ellipse_4" data-name="Ellipse 4" cx="2.576" cy="2.576" r="2.576" transform="translate(-15 125.125)" fill="#fff"/>
                    <circle id="Ellipse_5" data-name="Ellipse 5" cx="2.576" cy="2.576" r="2.576" transform="translate(146.258 118.401)" fill="#ffb001"/>
                    <circle id="Ellipse_6" data-name="Ellipse 6" cx="2.576" cy="2.576" r="2.576" transform="translate(155.058 228.583)" fill="#fff"/>
                    <circle id="Ellipse_7" data-name="Ellipse 7" cx="2.576" cy="2.576" r="2.576" transform="translate(208.517 280.224)" fill="#fff"/>
                    <circle id="Ellipse_8" data-name="Ellipse 8" cx="2.576" cy="2.576" r="2.576" transform="translate(199.85 134.01)" fill="#fff"/>
                    <circle id="Ellipse_9" data-name="Ellipse 9" cx="2.576" cy="2.576" r="2.576" transform="translate(193.535 72.602)" fill="#fff"/>
                    <circle id="Ellipse_10" data-name="Ellipse 10" cx="2.576" cy="2.576" r="2.576" transform="translate(179.09)" fill="#fff"/>
                    <circle id="Ellipse_11" data-name="Ellipse 11" cx="2.576" cy="2.576" r="2.576" transform="translate(34.438 2.576)" fill="#fff"/>
                    <circle id="Ellipse_12" data-name="Ellipse 12" cx="2.576" cy="2.576" r="2.576" transform="translate(113.848 361.312)" fill="#fff"/>
                    <circle id="Ellipse_13" data-name="Ellipse 13" cx="2.576" cy="2.576" r="2.576" transform="translate(85.266 368.311)" fill="#fff"/>
                    <circle id="Ellipse_14" data-name="Ellipse 14" cx="2.576" cy="2.576" r="2.576" transform="translate(2.268 202.841)" fill="#fff"/>
                    <circle id="Ellipse_15" data-name="Ellipse 15" cx="2.576" cy="2.576" r="2.576" transform="translate(176.514 371.231)" fill="#fff"/>
                    <circle id="Ellipse_16" data-name="Ellipse 16" cx="2.576" cy="2.576" r="2.576" transform="translate(102.046 9.919)" fill="#fff"/>
                    <path id="Path_73" data-name="Path 73" d="M93.22,216.761a2.576,2.576,0,1,1-2.575-2.576A2.575,2.575,0,0,1,93.22,216.761Z" transform="translate(40.771 162.565)" fill="#ffb001"/>
                    <path id="Path_74" data-name="Path 74" d="M133,444.819a2.576,2.576,0,1,1-2.576-2.575A2.576,2.576,0,0,1,133,444.819Z" transform="translate(-99.935 -85.381)" fill="#fff"/>
                    <path id="Path_75" data-name="Path 75" d="M47.213,405.848a2.576,2.576,0,1,1-2.576-2.576A2.576,2.576,0,0,1,47.213,405.848Z" transform="translate(-46.757 -85.381)" fill="#fff"/>
                    <circle id="Ellipse_17" data-name="Ellipse 17" cx="5.152" cy="5.152" r="5.152" transform="translate(167.891 320.467)" fill="#fff"/>
                    <path id="Path_76" data-name="Path 76" d="M444.32,135.291a5.152,5.152,0,1,1-5.152-5.152A5.152,5.152,0,0,1,444.32,135.291Z" transform="translate(-263.946 -43.533)" fill="#fff"/>
                    <path id="Path_77" data-name="Path 77" d="M297.237,82.284a5.152,5.152,0,1,1-5.152-5.152A5.152,5.152,0,0,1,297.237,82.284Z" transform="translate(-174.622 -30.414)" fill="#fff"/>
                    <path id="Path_78" data-name="Path 78" d="M466.109,235.166a5.152,5.152,0,1,1-5.152-5.152A5.152,5.152,0,0,1,466.109,235.166Z" transform="translate(-259.998 -60.672)" fill="#fff"/>
                    <circle id="Ellipse_18" data-name="Ellipse 18" cx="5.152" cy="5.152" r="5.152" transform="translate(28.166 307.4)" fill="#ffb001"/>
                    <circle id="Ellipse_19" data-name="Ellipse 19" cx="5.152" cy="5.152" r="5.152" transform="translate(77.797 45.56)" fill="#ffb001"/>
                    <circle id="Ellipse_20" data-name="Ellipse 20" cx="7.344" cy="7.344" r="7.344" transform="translate(41.015 43.368)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                    <circle id="Ellipse_21" data-name="Ellipse 21" cx="7.344" cy="7.344" r="7.344" transform="translate(-4.046 276.791)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                    <circle id="Ellipse_22" data-name="Ellipse 22" cx="7.344" cy="7.344" r="7.344" transform="translate(19.111 9.919)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                    <circle id="Ellipse_23" data-name="Ellipse 23" cx="7.344" cy="7.344" r="7.344" transform="translate(45.574 382.932) rotate(-80.761)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                    <circle id="Ellipse_24" data-name="Ellipse 24" cx="7.344" cy="7.344" r="7.344" transform="translate(185.461 254.193)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                    <circle id="Ellipse_25" data-name="Ellipse 25" cx="7.344" cy="7.344" r="7.344" transform="translate(-14.616 359.12)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                    <circle id="Ellipse_26" data-name="Ellipse 26" cx="7.344" cy="7.344" r="7.344" transform="translate(152.06 14.2)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"/>
                </g>
                </g>
                <text id="POR_TEMPO_LIMITADO_OU_ATÉ_O_ESTOQUE_ACABAR" data-name="POR TEMPO LIMITADO OU ATÉ O ESTOQUE ACABAR" transform="translate(239 778.105)" fill="#fff" font-size="8.5" font-family="ArialMT, Arial"><tspan x="14.963" y="8">POR TEMPO LIMITADO OU </tspan><tspan x="16.136" y="23">ATÉ O ESTOQUE ACABAR</tspan></text>
                <g id="Group_2020" data-name="Group 2020" transform="translate(135 427)">
                <g id="Group_58" data-name="Group 58" transform="translate(72.741 135.291)">
                    <path id="Path_54" data-name="Path 54" d="M154.745,379.251l74.592,12.714,1.668-14.187Z" transform="translate(-123.261 -194.03)" fill="#e59900"/>
                    <path id="Path_55" data-name="Path 55" d="M108,302.875l40.763,14.481,2.416-21.643Z" transform="translate(-108 -174.151)" fill="#d82323"/>
                    <path id="Path_56" data-name="Path 56" d="M308.016,146.492l-72.516-11.2V148.71Z" transform="translate(-149.626 -135.291)" fill="#e5e5e5"/>
                    <path id="Path_57" data-name="Path 57" d="M154.745,298.2v61.773H294.838L291.47,298.2Z" transform="translate(-123.261 -174.754)" fill="#ffb001"/>
                    <path id="Path_58" data-name="Path 58" d="M365.458,208.481,314.917,194.8l-2.862,20.236Z" transform="translate(-174.619 -149.705)" fill="#d82323"/>
                    <path id="Path_59" data-name="Path 59" d="M135.27,212.966,138.3,144.25l136.993,4.412-.941,64.3Z" transform="translate(-116.903 -137.461)" fill="#fff"/>
                    <path id="Path_60" data-name="Path 60" d="M155.333,300.667,292.74,318.556l-.891-16.344Z" transform="translate(-123.453 -175.351)" fill="#e59900"/>
                    <path id="Path_61" data-name="Path 61" d="M136.219,206.467l137.124,5.959L135.262,220.2Z" transform="translate(-116.901 -152.532)" fill="#e5e5e5"/>
                    <path id="Path_62" data-name="Path 62" d="M109.165,217.767,108,282.8l191.281.129-.441-70.076Z" transform="translate(-108 -154.08)" fill="#ed3d35"/>
                </g>
                </g>
                <g id="Group_2021" data-name="Group 2021" transform="translate(5063 457)">
                <g id="Group_2021-2" data-name="Group 2021">
                    <text id="SUPER" transform="translate(-4917.445 123.551)" fill="#231f20" font-size="30" font-family="Arial-BoldMT, Arial" font-weight="700"><tspan x="100.847" y="27">SUPER</tspan></text>
                    <text id="OFERTAS" transform="translate(-4912.053 180.972)" fill="#fff" font-size="40" font-family="Arial-BoldMT, Arial" font-weight="700"><tspan x="58.454" y="36">OFERTAS</tspan></text>
                    <text id="_45_" data-name="45%" transform="translate(-4745.34 280.678)" fill="#231f20" font-size="50" font-family="Arial-BoldMT, Arial" font-weight="700"><tspan x="-40.774" y="0">{{promotion}}</tspan><tspan y="0" font-size="29.165" baseline-shift="16.664999433269266">%</tspan></text>
                </g>
                <text id="OFF" transform="translate(-4706.918 280.551)" font-size="15" font-family="Arial-BoldMT, Arial" font-weight="700"><tspan x="-14.996" y="0">OFF</tspan></text>
                <text id="ATÉ" transform="translate(-4804.918 280.551)" font-size="15" font-family="Arial-BoldMT, Arial" font-weight="700"><tspan x="-14.443" y="0">ATÉ</tspan></text>
                </g>
            </g>
          </svg>

          <div class="action" *ngIf="(imageCapa!='' && imageCapa!='no')">
            <button type="button" (click)="onRemoveImage()" class="btn btn-secondary tred">Remover banner</button>
          </div>

          <div class="action" *ngIf="uploader.queue && uploader.queue.length > 0">
            <button type="button" (click)="onRemoveFileImage()" class="btn btn-secondary tred">Remover banner</button>
          </div>
        </div>
        <div class="no-products dnone" [class.dnone]="produtos.length > 0">
          A vitrine está vazia!
        </div>
        <div class="products-wrapper" [class.rightArrow]="arrowRight" [class.leftArrow]="arrowLeft" [class.dnone]="produtos.length == 0">
          <a (click)="moveLeft()" class="left"></a>
          <div #listProducts cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" class="products">
            <div *ngFor="let product of produtos; let i=index" cdkDrag cdkDragLockAxis="x" class="showcase-product">
              <figure>
                <img [src]="product.image_default" onerror="this.onerror=null;this.src='/assets/img/produto_sem_foto.png'" />
              </figure>
              <small>Cód.: {{product.codbarra | mask: '0 000000 000000'}}</small>
              <strong>
                R$ {{(product.oferta_preco ? product.oferta_preco : product.preco) | number:'.2'}}
              </strong>
              <span>
                {{product.descricao}}
              </span>

              <div *ngIf="tipo.value == 'P'" class="action">
                <button type="button" (click)="onRemoveProduct(product, i)" class="btn btn-secondary tred">Remover da vitrine</button>
              </div>

              <div class="cdkDragHandle" cdkDragHandle><i class="ic ic-dots"></i></div>
            </div>
          </div>
          <a (click)="moveRight()" class="right"></a>
        </div>
      </div>
    </section>

    <section class="pnl pnl-content pnl-content-program">
      <strong>Configurações</strong>
      <div class="config">
        <ul>
          <li>
            <div class="ipt-switch">
              <input id="randomico" formControlName="randomico" (change)="onChangeDetail()" name="randomico" type="checkbox" value="1">
              <label for="randomico"></label>
            </div>
            <label for="diasemana_monday">
              Ordem randômica
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="carrossel" formControlName="carrossel" (change)="onChangeDetail()" name="carrossel" type="checkbox" value="1">
              <label for="carrossel"></label>
            </div>
            <label for="diasemana_tuesday">
              Movimentação automática
            </label>
          </li>
        </ul>
      </div>
      <strong>Programação</strong>
      <div>
        <mat-radio-group formControlName="select_program">
          <mat-radio-button name="select_program" value="1">Definir uma data para iniciar e outra para expirar</mat-radio-button>
          <mat-radio-button name="select_program" value="2">Escolher um dia da semana para mostrar automaticamente</mat-radio-button>
        </mat-radio-group>
      </div>
      <div *ngIf="select_program.value == 1" class="range-date">
        <div>
          <label>Data de início</label>
          <div class="frm-datepicker">
              <input type="text" formControlName="dt_start" class="form-control" (dateInput)="onChangeDetail()" [matDatepicker]="pickerInicialDate" />
              <mat-datepicker-toggle matSuffix [for]="pickerInicialDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerInicialDate></mat-datepicker>
          </div>
        </div>
        <div>
          <label>Data expiração</label>
          <div class="frm-datepicker">
            <input type="text" formControlName="dt_expired" [min]="dt_start.value" (dateInput)="onChangeDetail()" class="form-control" [matDatepicker]="pickerDtEnd" />
            <mat-datepicker-toggle matSuffix [for]="pickerDtEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerDtEnd></mat-datepicker>
          </div>
        </div>
      </div>
      <div *ngIf="select_program.value == 2" class="days">
        <ul>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_monday" formControlName="diasemana_monday" (change)="onChangeDays(diasemana_monday)" name="diasemana_monday" type="checkbox" value="1">
              <label for="diasemana_monday"></label>
            </div>
            <label for="diasemana_monday">
              Mostrar em todas as Segundas-feiras
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_tuesday" formControlName="diasemana_tuesday" (change)="onChangeDays(diasemana_tuesday)" name="diasemana_tuesday" type="checkbox" value="2">
              <label for="diasemana_tuesday"></label>
            </div>
            <label for="diasemana_tuesday">
              Mostrar em todas as Terças-feiras
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_wednesday" formControlName="diasemana_wednesday" (change)="onChangeDays(diasemana_wednesday)" name="diasemana_wednesday" type="checkbox" value="3">
              <label for="diasemana_wednesday"></label>
            </div>
            <label for="diasemana_wednesday">
              Mostrar em todas as Quartas-feiras
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_thursday" formControlName="diasemana_thursday" (change)="onChangeDays(diasemana_thursday)" name="diasemana_thursday" type="checkbox" value="4">
              <label for="diasemana_thursday"></label>
            </div>
            <label for="diasemana_thursday">
              Mostrar em todas as Quintas-feiras
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_friday" formControlName="diasemana_friday" (change)="onChangeDays(diasemana_friday)" name="diasemana_friday" type="checkbox" value="5">
              <label for="diasemana_friday"></label>
            </div>
            <label for="diasemana_friday">
              Mostrar em todas as Sextas-feiras
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_saturday" formControlName="diasemana_saturday" (change)="onChangeDays(diasemana_saturday)" name="diasemana_saturday" type="checkbox" value="6">
              <label for="diasemana_saturday"></label>
            </div>
            <label for="diasemana_saturday">
              Mostrar em todos os Sábados
            </label>
          </li>
          <li>
            <div class="ipt-switch">
              <input id="diasemana_sunday" formControlName="diasemana_sunday" (change)="onChangeDays(diasemana_sunday)" name="diasemana_sunday" type="checkbox" value="7">
              <label for="diasemana_sunday"></label>
            </div>
            <label for="diasemana_sunday">
              Mostrar em todos os Domingos
            </label>
          </li>
        </ul>
      </div>
    </section>

    <section class="pnl pnl-content pnl-content-banner">
      <div class="image-wrapper">
        <div class="image-dragged" ng2FileDrop [uploader]="uploader_banner" (fileOver)="fileOverBaseBanner($event)" [class.dnone]="((imageBanner!='') || (uploader_banner.queue && uploader_banner.queue.length > 0))" [ngClass]="{ 'nv-file-over': hasBaseDropZoneBannerOver }">
          <i class="ic ic-no-image-medium"></i>
          <strong>Arraste e solte aqui a imagem do banner da página interna <b>900 x 240</b></strong>
          <input id="fileUploaderBanner" #fileUploaderBanner type="file" ng2FileSelect [uploader]="uploader_banner" class="dnone">
          <button (click)="fileUploaderBanner.click()" type="button" class="btn btn-primary-outline">ou clique aqui para buscar</button>
        </div>

        <div *ngIf="((uploader_banner.queue && uploader_banner.queue.length > 0) || imageBanner != '')" class="image-cover image-cover-desktop">
          <div class="actions">
            <a (click)="onRemoveImageBanner()"><i class="ic ic-delete"></i>Excluir imagem</a>
            <a [href]="imageBanner" target="_blank"><i class="ic ic-download"></i>Baixar imagem</a>
          </div>
          <img [src]="imageBanner" *ngIf="imageBanner!=''" />
          <img *ngFor="let item of uploader_banner.queue; let i=index" src="" imgPreview [image]="item?._file" />
        </div>
      </div>
      <div class="infos">
        <div>
          <label>Título <i>(legenda do banner)</i></label>
          <input type="text" class="form-control" formControlName="titulo_banner" (keyup)="onChangeDetail()" />
        </div>
      </div>
    </section>
  </form>

  <div *ngIf="showModal" class="modal" [class.open]="openModal">
    <div class="modal-content modal-large">
        <header>
          <div>
            <ng-select placeholder="Marcas" [(ngModel)]="flMarca" (clear)="onCleanFilterMarca()" (change)="onSelectFilterChange()" [items]="brands" bindLabel="marca" bindValue="marca"></ng-select>
          </div>
          <div>
            <ng-select placeholder="Categorias" [(ngModel)]="flCategoria" (clear)="onCleanFilterCategoria()" (change)="onSelectFilterChange()" [items]="categories" bindLabel="ds_categoria" bindValue="idcategoria"></ng-select>
          </div>
          <div>
            <input type="text" class="form-control" [(ngModel)]="strSearch" (keyup)="resetPageSearch()" placeholder="Digite para filtrar..." />
            <i class="ic ic-magnifying"></i>
            <a class="btn-close dnone"></a>
          </div>
        </header>
        <section infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="20" (scrolled)="onScroll()">
            <div *ngFor="let product of products; let i=index" [class.active]="product.selected" (click)="selectProduct(product)">
                <figure>
                    <img [src]="product.image" onerror="this.onerror=null;this.src='/assets/img/produto_sem_foto.png'" />
                    <b class="check"></b>
                </figure>
                <div class="description">
                    <span>{{product.descricao}}</span>
                    <strong>{{product.codbarra | mask: '0 000000 000000'}}</strong>
                </div>
                <div class="price">
                    R$ {{product.preco | number:'.2'}}
                </div>
            </div>

            <div class="loading" *ngIf="loadingProducts" [class.loading-inital]="page==1">
                <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
                    <div class="ldio-ns36390yc">
                        <div></div>
                    </div>
                </div>
            </div>
        </section>
        <footer>
            <span>{{produtosSelected.length+produtos.length}} selecionado</span>
            <button (click)="closeModalProducts()" type="button" class="btn btn-primary-outline">CANCELAR</button>
            <button (click)="putProducts()" type="button" class="btn btn-primary">ATRIBUIR</button>
        </footer>
    </div>
  </div>
</div>
